const ProfileModals = {
  LOGIN: 1,
  REGISTER: 2,
};

export default ProfileModals;